import { store } from '../../../../resources/frontend/js/store/index';

/**
 * Listen to isDesktop change
 * @param {number} step
 * @param {function} callback
 */
export const isDesktopListener = (step, callback) => {
  const isDesktop = window.matchMedia('(min-width: 1024px)');

  const callIsDesktopListenerCallback = () => {
    if (step === 0) {
      callback();
      return;
    }

    if (store.state.page.step !== step && store.state.page.steps.length > 1) {
      isDesktop.removeEventListener('change', callIsDesktopListenerCallback);
    } else {
      callback();
    }
  };

  if (typeof callback === 'function') {
    isDesktop.addEventListener('change', callIsDesktopListenerCallback);
  }
};
